type AdminRuntimeConfig = Record<string, string | undefined>;

declare global {
  interface Window {
    __GYFTPRO_ADMIN_RUNTIME_CONFIG__?: AdminRuntimeConfig;
  }
}

export function readRuntimeEnv(key: string): string | undefined {
  const runtimeValue = globalThis.window?.__GYFTPRO_ADMIN_RUNTIME_CONFIG__?.[key];
  if (typeof runtimeValue === "string") {
    return runtimeValue;
  }

  const viteEnv = (import.meta as ImportMeta & { env?: AdminRuntimeConfig }).env;
  return viteEnv?.[key];
}

export function readRuntimeNumber(key: string, fallback: number): number {
  const value = readRuntimeEnv(key)?.trim();
  if (!value) {
    return fallback;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}
